document.addEventListener("DOMContentLoaded", () => {
  // 1. 找到页面上所有包含倒计时日期的元素
  const countdownElements = document.querySelectorAll("[data-countdown-t4s][data-date]");

  countdownElements.forEach((el) => {
    const targetDateStr = el.getAttribute("data-date"); // 获取 "2026/12/26"
    const targetDate = new Date(targetDateStr).getTime();

    if (isNaN(targetDate)) {
      console.error(`无效的日期格式: ${targetDateStr}`);
      return;
    }

    // 2. 启动该组件的定时器
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const timeRemaining = targetDate - now;

      if (timeRemaining <= 0) {
        clearInterval(interval);
        handleCountdownEnd(el);
        return;
      }

      // 计算 天、时、分、秒
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // 3. 分别更新四个卡片，天数如果是三位数（如165）不需要强行补零
      // 如果天数为0，则移除
      updateCard(el.querySelector(".countdown-days"), days, false);
      updateCard(el.querySelector(".countdown-hours"), hours, true);
      updateCard(el.querySelector(".countdown-min"), minutes, true);
      updateCard(el.querySelector(".countdown-sec"), seconds, true);
    }, 1000);
  });

  // 核心：处理单个卡片的翻页数据与动画
  function updateCard(cardEl, newValue, padZero) {
    if (!cardEl) return;

    const flipCardInner = cardEl.querySelector(".flip-card");
    // 1. 状态锁：如果当前卡片正在执行翻页动画，直接拦截，防止连续触发导致数据错乱
    if (flipCardInner.classList.contains("flipping")) return;
    // 格式化数字：天数通常不补0，时分秒补0变成双位数
    const formattedValue = padZero && newValue < 10 ? `0${newValue}` : String(newValue);

    // 获取内部的所有数字面板
    const topNode = cardEl.querySelector(".cd-top span");
    const bottomNode = cardEl.querySelector(".cd-bottom span");
    const topFlipNode = cardEl.querySelector(".top-flip span");
    const bottomFlipNode = cardEl.querySelector(".bottom-flip span");
    // 2. 优先从 DOM 属性读取绝对真实的“旧值”，读取不到再用 text
    let currentValue = cardEl.getAttribute("data-current-val");
    if (!currentValue) {
        currentValue = topNode.innerText.trim();
    }

    // 如果数字没有变化，直接返回，不触发任何操作
    if (currentValue === formattedValue) return;
    // 3. 强行锁定当前新值为下一次的“旧值”
    cardEl.setAttribute("data-current-val", formattedValue);

    // --- 翻页动画核心逻辑，渲染顺序 ---
    // A. 先把“即将往下翻”的前半张牌（top-flip）和“在下面等待承接”的后半张牌（bottom-flip）写上新数字
    topFlipNode.innerText = currentValue; // 显式强制：翻转牌必须是真实的旧值
    bottomFlipNode.innerText = formattedValue;

    // B. 此时，先不要动背景墙 topNode 的值，等一个微小的宏任务（setTimeout）
    setTimeout(() => {
        // D. 触发动画
        flipCardInner.classList.add("flipping"); // 给整个卡片容器加上正在翻页的类
        
        // E. 动画开始的同时，把被盖住的背景上半部分悄悄换成新值
        topNode.innerText = formattedValue;
    }, 10);

    // C. 动画结束（0.6秒）后，同步全盘数据，解锁状态，同步静态背景牌的数字，并移除动画类
    // 使用 once: true 确保事件触发一次后自动销毁
    flipCardInner.addEventListener("animationend", () => {
      bottomNode.innerText = formattedValue;
      topFlipNode.innerText = formattedValue; // 复位
      flipCardInner.classList.remove("flipping");
    }, { once: true });
  }

  // 倒计时结束时的回调（可根据需求修改）
  function handleCountdownEnd(el) {
    el.innerHTML = '<div class="countdown-ended">Promotion Ended</div>';
  }
});